export const ARCHETYPES = {
  CHOMPERS: "CHOMPERS",
  SUCKERS: "SUCKERS",
  PEEPERS: "PEEPERS",
  SHELLS: "SHELLS",
  SLIME: "SLIME",
  FEELERS: "FEELERS",
  SCUTTLERS: "SCUTTLERS",
  GRIPPERS: "GRIPPERS",
  WINGS: "WINGS",
  GLANDS: "GLANDS",
  TAILS: "TAILS",
  BUILD: "BUILD",
  BRAIN: "BRAIN",
  COMPANIONS: "COMPANIONS",
  MOUNTS: "MOUNTS",
  TOOLS: "TOOLS",
  WEAPONS: "WEAPONS",
  THREADS: "THREADS",
};

export const ARCHETYPES_CONFIG = {
  [ARCHETYPES.CHOMPERS]: {
    label: "Chompers",
    singularLabel: "Chomper",
    color: "#813332",
  },
  [ARCHETYPES.SUCKERS]: {
    label: "Suckers",
    singularLabel: "Sucker",
    color: "#AC6B34",
  },
  [ARCHETYPES.PEEPERS]: {
    label: "Peepers",
    singularLabel: "Peeper",
    color: "#0087BF",
  },
  [ARCHETYPES.SHELLS]: {
    label: "Shells",
    singularLabel: "Shell",
    color: "#713D6C",
  },
  [ARCHETYPES.SLIME]: {
    label: "Slime",
    singularLabel: "Slime",
    color: "#32576D",
  },
  [ARCHETYPES.FEELERS]: {
    label: "Feelers",
    singularLabel: "Feeler",
    color: "#96533B",
  },
  [ARCHETYPES.SCUTTLERS]: {
    label: "Scuttlers",
    singularLabel: "Scuttler",
    color: "#384835",
  },
  [ARCHETYPES.GRIPPERS]: {
    label: "Grippers",
    singularLabel: "Gripper",
    color: "#9882AB",
  },
  [ARCHETYPES.WINGS]: {
    label: "Wings",
    singularLabel: "Wing",
    color: "#D49E44",
  },
  [ARCHETYPES.GLANDS]: {
    label: "Glands",
    singularLabel: "Gland",
    color: "#D77CA2",
  },
  [ARCHETYPES.TAILS]: {
    label: "Tails",
    singularLabel: "Tail",
    color: "#788869",
  },
  [ARCHETYPES.BUILD]: {
    label: "Build",
    singularLabel: "Build",
    color: "#BE8565",
  },
  [ARCHETYPES.BRAIN]: {
    label: "Brain",
    singularLabel: "Brain",
    color: "#4C3972",
  },
  [ARCHETYPES.COMPANIONS]: {
    label: "Companions",
    singularLabel: "Companion",
    color: "#829048",
  },
  [ARCHETYPES.MOUNTS]: {
    label: "Mounts",
    singularLabel: "Mount",
    color: "#865F3A",
  },
  [ARCHETYPES.TOOLS]: {
    label: "Tools",
    singularLabel: "Tool",
    color: "#00858B",
  },
  [ARCHETYPES.WEAPONS]: {
    label: "Weapons",
    singularLabel: "Weapon",
    color: "#4D5A5F",
  },
  [ARCHETYPES.THREADS]: {
    label: "Threads",
    singularLabel: "Thread",
    color: "#523B26",
  },
};

export const ARCHETYPE_ITEMS = Object.entries(ARCHETYPES_CONFIG).map(
  ([key, value]) => ({
    id: key,
    ...value,
  })
);
